import UpdateLicensePage from './UpdateLicensePage';

export default UpdateLicensePage;
